import { Box, Stack } from "@mui/material";

export default function ColorBars() {
   return (
      <Stack
         sx={{ width: "100%", height: "100%" }}
         alignItems='flex-start'
      >
         <Stack
            direction='row'
            justifyContent='flex-start'
            alignItems='stretch'
            sx={{ width: "100%", height: "60%" }}
         >
            <Box
               sx={{
                  backgroundColor: "rgb(104,104,104)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(180,180,180)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(180,180,16)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(16,180,180)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(16,180,16)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(180,16,180)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(180,16,16)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(16,16,180)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(104,104,104)",
                  width: "11.111111%",
               }}
            />
         </Stack>
         <Stack
            direction='row'
            justifyContent='flex-start'
            alignItems='stretch'
            sx={{ width: "100%", height: "10%" }}
         >
            <Box
               sx={{
                  backgroundColor: "rgb(16,235,235)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(16,70,106)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(180,180,180)",
                  width: "66.6666667%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(16,16,235)",
                  width: "11.111111%",
               }}
            />
         </Stack>
         <Stack
            direction='row'
            justifyContent='flex-start'
            alignItems='stretch'
            sx={{ width: "100%", height: "10%" }}
         >
            <Box
               sx={{
                  backgroundColor: "rgb(235,235,16)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(72,16,118)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  background: "linear-gradient(90deg, black, white);",
                  width: "66.6666667%",
               }}
            />
            <Box
               sx={{
                  background: "rgb(235,16,16)",
                  width: "11.111111%",
               }}
            />
         </Stack>
         <Stack
            direction='row'
            justifyContent='flex-start'
            alignItems='stretch'
            sx={{ width: "100%", height: "20%" }}
         >
            <Box
               sx={{
                  backgroundColor: "rgb(47,47,47)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(0,0,0)",
                  width: "11.111111%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(255,255,255)",
                  width: "22.222222%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(0,0,0)",
                  width: "44.4444444%",
               }}
            />
            <Box
               sx={{
                  backgroundColor: "rgb(47,47,47)",
                  width: "11.111111%",
               }}
            />
         </Stack>
      </Stack>
   );
}
